<div id="td-area-header">
  <app-terms-and-conditions></app-terms-and-conditions>
</div>
<mat-accordion>
  <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
    <mat-expansion-panel-header>
      <div class="td-header-area" fxFlex>
        <h2>
          <mat-panel-title role="button">E-Sign Disclosure & Consent Agreement</mat-panel-title>
        </h2>
      </div>
    </mat-expansion-panel-header>
    <div [ngClass]="{ 'mobile-container': isMobile }">
      <div class="td-area-wrapper">
        This consent applies to any {{ brandName }} account information that you
        or we elect at any time to provide electronically including all
        disclosures, agreements, and other documents relating to your
        account(s). It also permits us to obtain your Electronic Signature in
        connection with your {{ brandName }} account. To receive information
        electronically, you need: an internet connection, email, a way to store
        these documents and software to view and print PDF files. You can update
        your email online once your account is open.
      </div>
      <div class="td-area-wrapper">
        To obtain paper copies of what we deliver electronically at no cost or
        withdraw your consent, call us at
        <a [href]="'tel:' + customerSupportPhone" class="link-btn-action">{{ customerSupportPhone }}</a
        >. If you withdraw your consent, you will lose online access and any
        scheduled transactions will be canceled.
      </div>
      <div class="td-area-wrapper">
        We will notify you of software and/or hardware changes that could
        prevent you from accessing or retaining these records. At that time, you
        will have the right to withdraw your consent at no cost.
      </div>
      <div class="td-area-wrapper">
        By selecting Continue below, you acknowledge that you have received and
        agree to the E-Sign Consent & Disclosure above. View and save the
        <a
          [href]="esignUrl"
          target="_blank"
          aria-label="opens e-sign url in new tab"
          class="link-btn-action"
          >disclosure</a
        >
        for your records.
      </div>
      <div fxLayoutAlign="center center" class="actions">
        <button
          (click)="acceptDocument(step); nextStep()"
          mat-flat-button
          color="primary"
          class="width-full primary-btn-action"
        >
          Continue
        </button>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel
    [expanded]="step === 1"
    (opened)="setStep(1)"
    [formGroup]="termsDisclosuresForm"
  >
    <mat-expansion-panel-header>
      <div class="td-header-area" fxFlex>
        <h2 role="button">
          <mat-panel-title>General Disclosures</mat-panel-title>
        </h2>
      </div>
    </mat-expansion-panel-header>
    <div [ngClass]="{ 'mobile-container': isMobile }">
      <div class="td-area-wrapper">
        We’re required by law to give you certain disclosures and other
        information related to your {{ brandName }} accounts. To finish your
        application, we need you to verify that you have read and understood the
        information below:
        <ul class="list">
          <li *ngIf="bankingTermsDisclosuresUrl">
            <a
              [href]="bankingTermsDisclosuresUrl"
              target="_blank"
              aria-label="Opens personal and small business banking terms and disclosures pdf file in new tab"
              class="link-btn-action"
            >
              Personal and Small Business Banking Terms and Disclosures
            </a>
            (PDF)
          </li>
          <li *ngIf="electronicBankingTermsDisclosuresUrl">
            <a
              [href]="electronicBankingTermsDisclosuresUrl"
              target="_blank"
              aria-label="opens personal and Small Business Electronic Banking Terms and
              Disclosures pdf file in new tab "
              class="link-btn-action"
            >
              Personal and Small Business Electronic Banking Terms and
              Disclosures
            </a>
            (PDF)
          </li>
          <li *ngIf="tisaUrl">
            <a
              [href]="tisaUrl"
              target="_blank"
              aria-label="Opens Personal Truth in Savings Disclosures pdf file in new tab"
              class="link-btn-action"
            >
              Personal Truth in Savings Disclosures
            </a>
            (PDF)
          </li>
          <li *ngFor="let tisa of accountTISAs">
            <a
              [href]="tisa.PDFUrl"
              target="_blank"
              aria-label="Opens Personal Truth in Savings Disclosures pdf file in new tab "
              class="link-btn-action"
            >
              Personal Truth in Savings Disclosures {{ tisa.accountName }}
            </a>
            (PDF)
          </li>
          <li *ngIf="termsDisclosuresUrl">
            <a
              [href]="termsDisclosuresUrl"
              target="_blank"
              aria-label="Opens terms and disclosures pdf file in new tab"
              class="link-btn-action"
            >
              Terms and Disclosures
            </a>
            (PDF)
          </li>
          <li *ngIf="privacyNoticeUrl">
            <a
              [href]="privacyNoticeUrl"
              target="_blank"
              aria-label="Opens privacy notice pdf in new tab"
              (click)="downloadDocument(privacyNoticeUrl)"
              class="link-btn-action"
            >
              Privacy Notice
            </a>
            (PDF)
          </li>
          <li *ngIf="privacyPolicyUrl">
            <a
              [href]="privacyPolicyUrl"
              target="_blank"
              aria-label="Opens privacy policy pdf file in new tab"
              class="link-btn-action"
            >
              Privacy Policy
            </a>
            (PDF)
          </li>
        </ul>
      </div>
      <div class="td-area-wrapper">
        <mat-checkbox
          aria-describedby="note1 note2 note3 note4"
          formControlName="isAccepted"
          >By checking this box, you acknowledge that:</mat-checkbox
        >
        <ul class="list">
          <li id="note1">
            You’ve received and are able to view the {{ brandName }} Terms and
            Disclosures,
            <span *ngIf="tisaUrl"
              >the {{ brandName }} Personal Truth in Savings Disclosures,</span
            >
            the Privacy Notices and the Privacy Policy, and understand that
            their terms will govern your accounts once they are opened.
          </li>
          <li id="note2">
            You have been provided the opportunity to print or download copies
            of the {{ brandName }} Account Information above for your records.
          </li>
          <li id="note3">
            You authorize us to obtain a consumer report from a consumer
            reporting agency to verify information provided in your application
            or for any legitimate business purpose in connection with your
            {{ brandName }} accounts.
          </li>
          <li id="note4">
            You authorize your wireless carrier to use or disclose information
            about your account and your wireless device, if available, to us or
            our service provider from the duration of your business
            relationship, solely to help them identify you or your wireless
            device and to prevent fraud. For more information about how we treat
            your data, please visit
            <a [href]="privacySecurityCenterUrl" target="_blank" class="link-btn-action"
              >Privacy and Security Center</a
            >.
          </li>
        </ul>
      </div>
      <div class="td-area-wrapper">
        If you have trouble viewing, printing or downloading the
        {{ brandName }} Account Information, call us at
        <a [href]="'tel:' + customerSupportPhone" class="link-btn-action">{{ customerSupportPhone }}</a
        >.
      </div>
      <div fxLayoutAlign="center center" class="actions">
        <button
          (click)="acceptDocument(step); nextStep()"
          [disabled]="!(termsDisclosuresComplete$ | async)"
          mat-flat-button
          color="primary"
          class="width-full primary-btn-action"
        >
          Continue
        </button>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
    <mat-expansion-panel-header>
      <div class="td-header-area" fxFlex>
        <h2>
          <mat-panel-title role="button">Tax Certification</mat-panel-title>
        </h2>
      </div>
    </mat-expansion-panel-header>
    <div class="td-area-wrapper">
      Under penalties of perjury, I certify; that: (i) I have provided my true
      and correct taxpayer identification number; (ii) I am not subject to
      backup withholding because: (a) I am exempt from backup withholding, or
      (b) I have not been notified by the Internal Revenue Services (IRS) that I
      am subject to backup withholding as a result of a failure to report all
      interest or dividends, or (c) the IRS has notified me that I am no longer
      subject to backup withholding; and (iii) I am a U.S. Citizen or other U.S.
      person (defined in the IRS Form W-9 instructions).
    </div>
    <div fxLayoutAlign="center center" class="actions">
      <button
        (click)="acceptDocument(step); nextStep()"
        mat-flat-button
        color="primary"
        class="width-full primary-btn-action"
      >
        Certify
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>
